module.exports = __webpack_public_path__ + "static/media/elixir-exhibitions-img-1.24fe0fdb.jpg";